export default {"src":"/_next/static/media/chevronDownUiLight_16.26719900.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};